import { Component } from '@angular/core';

@Component({
	selector: 'op-esign-how-to-print-save-loan',
	templateUrl: './esign-how-to-print-save-loan.component.html',
	styles: ['']
})
export class EsignHowToPrintSaveLoanComponent {}
